<template>
  <div v-if="disableArrow">
    <div class="flex justify-between gap-5 border-b-2 items-center border-blue-500">
      <h2 class="py-3 font-bold text-xl grow">{{ props.title }}</h2>
      <slot name="header" />
    </div>
    <TheTransition>
      <div class="py-3">
        <slot></slot>
      </div>
    </TheTransition>
  </div>
  <div v-else>
    <div class="flex justify-between gap-5 border-b-2 items-center cursor-pointer" :class="open ? 'border-blue-500' : ''">
      <h2 class="py-3 font-bold text-xl grow" @click="open = !open">{{ props.title }}</h2>
      <slot name="header" />
      <i @click="open = !open" :class="[{ 'rotate-180': open }, 'fa fa-chevron-down']"></i>
    </div>
    <TheTransition>
      <div v-if="open" class="py-3">
        <slot></slot>
      </div>
    </TheTransition>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  title: String,
  disableArrow: { type: Boolean, default: false },
  startsOpen: { type: Boolean, default: true },
})

const open = ref(props.startsOpen)
</script>
